export const isoStandard = (number) =>
  new Intl.NumberFormat('en-US', { useGrouping: true }).format(number);
